import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import useTableContext, {
  PageType
} from '../../../../admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';

export interface WithInnerLayoutProps {
  isInnerLayoutOpen: boolean;
  setIsInnerLayoutOpen: Dispatch<SetStateAction<boolean>>;
}

const WithInnerLayout =
  <CProps extends WithInnerLayoutProps>(Component: React.FC<CProps>) =>
  (props: CProps) => {
    const {
      context: { setPageType }
    } = useTableContext();

    const [isInnerLayoutOpen, setIsInnerLayoutOpen] = useState(false);

    useEffect(() => {
      isInnerLayoutOpen
        ? setPageType(PageType.DETAIL)
        : setPageType(PageType.LIST);
    }, [isInnerLayoutOpen]);

    return (
      <Component
        {...props}
        isInnerLayoutOpen={isInnerLayoutOpen}
        setIsInnerLayoutOpen={setIsInnerLayoutOpen}
      />
    );
  };

export default WithInnerLayout;
